export enum MenuButtons {
  StreetView = 'Street View',
  SettingsAndCustomization = 'Settings And Customization',
  Tools = 'Tools',
  DeleteMarker = 'Delete Marker',
  NavigateToGoogle = 'NavigateToGoogle',
  NavigateToApple = 'NavigateToApple',
}
